import { MandatoryAccountModal } from 'components/MandatoryAccountModal/MandatoryAccountModal';
import { Nothing } from 'components/Nothing/Nothing';
import {
  FF_MANDATORY_ACCOUNT_INDIA,
  FF_MANDATORY_ACCOUNT_INDIA_VERSION,
  PAYEX_PLATFORM,
} from 'constants/index';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  getPlatform,
  isPayingFromIndia,
  isUserCreated,
  paymentIsFromAgents,
} from 'selectors';
import { getTestVariant } from 'utils/getTestVariant/getTestVariant';

const REFETCH_TIMEOUT = 60000;

const MandatoryAccount = () => {
  const payingFromIndia = useSelector(isPayingFromIndia);
  const isFromAgents = useSelector(paymentIsFromAgents);
  const isPayexPlatform = useSelector(getPlatform) === PAYEX_PLATFORM;
  const userCreated = useSelector(isUserCreated);
  const showSignupTab = !userCreated;

  const isEligibleForIndia =
    !isFromAgents && isPayexPlatform && payingFromIndia;

  const { data: featureFlags } = usePeertransferFlags(
    [FF_MANDATORY_ACCOUNT_INDIA, FF_MANDATORY_ACCOUNT_INDIA_VERSION],
    {
      refetchInterval: REFETCH_TIMEOUT,
      enabled: isEligibleForIndia,
    },
  );

  const mandatoryAccountIndia =
    featureFlags?.[FF_MANDATORY_ACCOUNT_INDIA] ?? false;
  const mandatoryAccountIndiaVersion =
    featureFlags?.[FF_MANDATORY_ACCOUNT_INDIA_VERSION] ?? false;
  const testVariantForIndia = getTestVariant(
    mandatoryAccountIndia,
    mandatoryAccountIndiaVersion,
  );

  const activeModal = isEligibleForIndia && testVariantForIndia === 'C';

  return activeModal ? (
    <MandatoryAccountModal showSignupTab={showSignupTab} />
  ) : (
    <Nothing />
  );
};

export { MandatoryAccount };
